import { render, staticRenderFns } from "./alkohole.vue?vue&type=template&id=bdd8ff28&"
import script from "./alkohole.vue?vue&type=script&lang=js&"
export * from "./alkohole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports